import { rewardImage } from 'assets';
import Image from 'next/image';
import React from 'react';

const Rewards = () => {
  return (
    <div className='w-full h-full bg-dropDownMenuBg rounded-3xl p-6 flex-col flex gap-6 justify-between '>
      <div className='flex flex-col gap-2 '>
        <p className='text-lg leading-[26px] font-semibold text-white text-start'>
          Win Exciting Rewards Every Day
        </p>
        <p className='text-sm font-normal leading-[22px] text-grayZl-600 text-start'>
          Daily learning that actually sticks and feels effortless.
        </p>
      </div>
      <Image
        className='w-full'
        alt='rewardImage'
        width={340}
        height={140}
        src={rewardImage}
      />
    </div>
  );
};

export default Rewards;
